import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import ElevarIivAif from './components/ElevarIivAif';
import EeFiAif from './components/EeFiAif';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/elevar-i-iv-aif" element={<ElevarIivAif />} />
          <Route path="/ee-fi-aif" element={<EeFiAif />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;